export default __webpack_public_path__ + "static/media/blank_profile.7179f4c0.webp";